function importAll (r) {
  r.keys().forEach(r);
}

importAll(require.context('./', true, /\.png$/));
importAll(require.context('./', true, /\.jpg$/));
importAll(require.context('./', true, /\.jpeg$/));
importAll(require.context('./', true, /\.gif$/));
importAll(require.context('./', true, /\.svg$/));
